module.exports = __webpack_public_path__ + "img/notifications-w.svg";